/* Franja de condiciones: relevo por REGISTRO (plancha), no por desplazamiento.
   El estado NO se deja en manos de animaciones con fill:forwards: se cancela
   lo anterior, se anima, y al cerrar se fija el estado en el style inline.
   Invariante: exactamente un mensaje con el recorte abierto en todo momento. */
const { mount, reduced, EASE } = window.EQ;

const ENTRA = 420, SALE = 320, SOLAPE = 140;

mount('[data-eq-ticker]', (root) => {
  const msgs = () => Array.from(root.querySelectorAll('[data-eq-msg]'));
  let i = 0, reloj = 0, guard = 0, corriendo = false, onHero = null;
  const lento = reduced();
  const permanencia = () => Math.max(2600, Number(root.dataset.permanencia) || 5500);

  const fijar = (el, abierto) => {
    el.getAnimations().forEach((a) => a.cancel());
    el.style.clipPath = abierto ? 'inset(0 0 0 0)' : 'inset(100% 0 0 0)';
    el.style.transform = 'none';
  };
  const mover = (el, abrir, delay) => {
    el.getAnimations().forEach((a) => a.cancel());
    const cerradoAbajo = { clipPath: 'inset(100% 0 0 0)', transform: 'translateY(8px)' };
    const abierto = { clipPath: 'inset(0 0 0 0)', transform: 'none' };
    const cerradoArriba = { clipPath: 'inset(0 0 100% 0)', transform: 'translateY(-8px)' };
    const cuadros = abrir ? [cerradoAbajo, abierto] : [abierto, cerradoArriba];
    el.style.clipPath = cuadros[0].clipPath;
    el.style.transform = cuadros[0].transform;
    const an = el.animate(cuadros, { duration: abrir ? ENTRA : SALE, delay: delay || 0, easing: EASE, fill: 'both' });
    an.onfinish = () => fijar(el, abrir);
  };
  const paso = () => {
    const m = msgs();
    if (m.length < 2) return;
    const sale = m[i];
    i = (i + 1) % m.length;
    const entra = m[i];
    m.forEach((el) => { if (el !== sale && el !== entra) fijar(el, false); });
    mover(sale, false, 0);
    mover(entra, true, Math.max(0, SALE - SOLAPE));
    reloj = setTimeout(paso, permanencia());
  };
  const arrancar = () => {
    if (corriendo || lento || root.dataset.rotar === 'false') return;
    const m = msgs();
    if (m.length < 2) return;
    corriendo = true;
    m.forEach((el, k) => fijar(el, k === i));
    reloj = setTimeout(paso, permanencia());
  };

  /* Fija: la franja se pega al borde superior. El envoltorio de seccion de
     Shopify (#shopify-section-x) mide exactamente lo que la franja, y un sticky
     no sale de su bloque contenedor: hay que pegar tambien los envoltorios que
     calzan con su alto. El header baja su tope el alto de la franja via
     --eq-ticker-h (lo lee el CSS del header y la barra de los catalogos). */
  const envs = [];
  const aplicarFija = () => {
    const fija = root.dataset.fija === 'true';
    const h = root.getBoundingClientRect().height || 48;
    let p = root.parentElement;
    while (p && p !== document.body && p.offsetHeight <= h + 2) { envs.push(p); p = p.parentElement; }
    envs.forEach((el) => {
      el.style.position = fija ? 'sticky' : '';
      el.style.top = fija ? '0px' : '';
      el.style.zIndex = fija ? '50' : '';
    });
    document.documentElement.style.setProperty('--eq-ticker-h', fija ? Math.round(h) + 'px' : '0px');
  };
  aplicarFija();

  if (root.dataset.espera === 'true') {
    onHero = () => arrancar();
    window.addEventListener('eq:heroListo', onHero, { once: true });
    guard = setTimeout(arrancar, 5200);
  } else {
    guard = setTimeout(arrancar, 600);
  }

  return () => {
    msgs().forEach((el) => el.getAnimations().forEach((a) => a.cancel()));
    clearTimeout(reloj); clearTimeout(guard);
    if (onHero) window.removeEventListener('eq:heroListo', onHero);
    envs.forEach((el) => { el.style.position = ''; el.style.top = ''; el.style.zIndex = ''; });
    document.documentElement.style.setProperty('--eq-ticker-h', '0px');
  };
});
